import React, { useEffect, useState, useCallback } from "react";
import "./MyResponse.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faCircleArrowLeft,
  faCircleInfo,
} from "@fortawesome/free-solid-svg-icons";

import ResponceDetails from "../ResponceDetails/ResponceDetails";
import { documentService, formService } from "../../../service";

import "../FormsDetailsContent/FormsDetailsContent.css";
import EditResponseOffcanvas from "../EditResponse/EditResponse.jsx";

const MyResponse = ({ formId, onBack }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [formInfo, setFormInfo] = useState(null);
  const [showEdit, setShowEdit] = useState(false);

  // -----------------------------------------------------------------------------
  // Fetch data (wrapped in useCallback to avoid useEffect warning)
  // -----------------------------------------------------------------------------
  const fetchData = useCallback(async () => {
    try {
      const { data: form } = await formService.getById(formId);
      setFormInfo(form);

      const { data: docs } = await documentService.getByForm(formId);
      setDocuments(docs);
    } catch (err) {
      console.error("Erreur lors du chargement :", err);
    }
  }, [formId]);

  useEffect(() => {
    if (formId) fetchData();
  }, [formId, fetchData]);

  // -----------------------------------------------------------------------------
  // Auto-refresh after editing a document
  // -----------------------------------------------------------------------------
  const reloadDocuments = useCallback(async () => {
    try {
      const { data: docs } = await documentService.getByForm(formId);
      setDocuments(docs);
    } catch (err) {
      console.error("Erreur lors du rechargement :", err);
    }
  }, [formId]);

  // -----------------------------------------------------------------------------
  // Offcanvas controls
  // -----------------------------------------------------------------------------
  const openOffcanvas = (doc) => {
    setSelectedDoc(doc);
    setShowOffcanvas(true);
  };

  const closeOffcanvas = () => {
    setSelectedDoc(null);
    setShowOffcanvas(false);
  };

  return (
    <div
      className="content flex-grow-1 px-3 py-4 mt-3"
      style={{ height: "100%" }}
    >
      <div className="container-fluid">
        {/* HEADER */}
        <div className="d-flex align-items-center gap-2 mb-3">
          <div
            className="d-flex align-items-center back-arrow"
            onClick={onBack}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faCircleArrowLeft} />
          </div>

          <div className="doc-form-title w-100 d-flex justify-content-center">
            Titre de formulaire : {formInfo?.title || "Formulaire"}
          </div>
        </div>

        {/* DESCRIPTION */}
        {formInfo?.description && (
          <div className="doc-form-description">
            <h6>Description :</h6>
            {formInfo.description}
          </div>
        )}

        {/* ACCORDION */}
        <div
          className="accordion mt-3 overflow-y-auto"
          id="accordionPanelsStayOpenExample"
        >
          {documents.length === 0 ? (
            <p className="mt-4 text-center text-muted">Aucun document trouvé</p>
          ) : (
            documents.map((doc, index) => {
              const entries = Object.entries(doc.values_json || {});
              const firstFive = entries.slice(0, 5);

              return (
                <div className="accordion-item" key={doc.id}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${
                        index !== 0 ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#doc-collapse-${index}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`doc-collapse-${index}`}
                    >
                      {doc.serial_number}
                    </button>
                  </h2>

                  <div
                    id={`doc-collapse-${index}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      {/* FIRST 5 FIELD RESPONSES */}
                      <div className="row g-3">
                        {firstFive.map(([key, value], i) => (
                          <div className="col-3" key={i}>
                            <div className="forme-attr py-1 px-4 d-flex flex-column justify-content-start align-items-start">
                              <span className="attr-label d-block">{key}</span>
                              <span
                                style={{
                                  fontWeight: "500",
                                  fontSize: "0.9rem",
                                }}
                              >
                                {String(value)}
                              </span>
                            </div>
                          </div>
                        ))}

                        {/* BUTTONS */}
                        <div className="col-3 d-flex justify-content-end align-items-center gap-2">
                          <button
                            className="details-btn"
                            onClick={() => openOffcanvas(doc)}
                          >
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="me-2"
                            />
                            Details
                          </button>

                          <button
                            className="details-btn"
                            onClick={() => {
                              setSelectedDoc(doc);
                              setShowEdit(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} className="me-2" />
                            Modifier
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* OFFCANVAS DETAILS */}
      <ResponceDetails
        show={showOffcanvas}
        onClose={closeOffcanvas}
        documentData={selectedDoc}
      />

      {/* EDIT RESPONSE OFFCANVAS */}
      <EditResponseOffcanvas
        show={showEdit}
        onClose={() => setShowEdit(false)}
        form={formInfo}
        documentData={selectedDoc}
        onUpdated={reloadDocuments} // 🔥 Auto refresh after editing
      />
    </div>
  );
};

export default MyResponse;
